import React, { FunctionComponent, useEffect, useState } from 'react';
import FundVideoProxy from './FundVideoProxy';
import withContext from '../../ContextAPI/Context_HOC';
import CircularProgress from '@material-ui/core/CircularProgress';

const VideoSwitcher: FunctionComponent<{
  context: { fundVideoProxy: FundVideoProxy };
}> = ({ context: { fundVideoProxy } }) => {
  const [videos, setVideos] = useState<any[]>([]);
  const [currentVideoId, setCurrentVideoId] = useState<string>('');
  const [error, setError] = useState<string | null>(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    setLoading(true);
    const fundVideoSubscription = fundVideoProxy.getFundVideoList().subscribe({
      next: (x) => {
        const fourNewestVideos = x.slice(0, 4);
        if (fourNewestVideos.length === 0) {
          setError('No videos found.');
          setVideos([]);
          setLoading(false);
          return;
        }
        setVideos(fourNewestVideos);
        setCurrentVideoId(fourNewestVideos[0].videoId.value);
        setError(null);
        setLoading(false);
      },
      error: () => {
        setError('Failed to load videos. Please try again later.');
        setVideos([]);
        setLoading(false);
      },
    });
    return () => {
      fundVideoSubscription.unsubscribe();
    };
  }, [fundVideoProxy]);

  const switchVideo = (id: string) => {
    setCurrentVideoId(id);
  };

  if (error) {
    return (
      <div className="fund-video-loading-container">
        <div className="error-message">{error}</div>
      </div>
    );
  }

  if (loading) {
    return (
      <div className="fund-video-loading-container">
        <CircularProgress data-cy="loading-animation-container" className="loading-animation" size={80} />
      </div>
    );
  }

  return (
    <div className="boxStyle">
      {currentVideoId && (
        <iframe
          id="videoPlayer"
          src={`https://player.vimeo.com/video/${currentVideoId}?h=2089eeef16`}
          width="100%"
          height="310"
          allow="autoplay; fullscreen; picture-in-picture"
          allowFullScreen
          title="Vimeo video player"
        />
      )}
      <div className="containerStyleFund">
        {videos.map((video, index) => (
          <div key={index} className="containerStyleFifty">
            {currentVideoId === video.videoId.value ? (
              <div data-cy="video-container">{video.system.name}</div>
            ) : (
              <a
                href="#"
                onClick={(e) => {
                  e.preventDefault();
                  switchVideo(video.videoId.value);
                }}
              >
                {video.system.name}
              </a>
            )}
          </div>
        ))}
      </div>
    </div>
  );
};

export default withContext(VideoSwitcher);
